<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/order' }">
        <app-i18n code="entities.order.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.order.edit.title" v-if="isEditing"></app-i18n>
        <app-i18n code="entities.order.new.title" v-if="!isEditing"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title">
        <app-i18n code="entities.order.edit.title" v-if="isEditing"></app-i18n>
        <app-i18n code="entities.order.new.title" v-if="!isEditing"></app-i18n>
      </h1>

      <div class="app-page-spinner" v-if="findLoading" v-loading="findLoading"></div>

      <el-form
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        :model="model"
        :rules="rules"
        @submit.native.prevent="doSubmit"
        class="form"
        ref="form"
        v-if="model"
      >
        <el-form-item :label="fields.id.label" :prop="fields.id.name" v-if="isEditing">
          <el-col :lg="11" :md="16" :sm="24">
            <el-input :disabled="true" v-model="model[fields.id.name]"/>
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.customer.label"
          :prop="fields.customer.name"
          :required="fields.customer.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <app-autocomplete-one-input
              :fetchFn="fields.customer.fetchFn"
              v-model="model[fields.customer.name]"
            ></app-autocomplete-one-input>
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.products.label"
          :prop="fields.products.name"
          :required="fields.products.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <app-autocomplete-many-input
              :fetchFn="fields.products.fetchFn"
              v-model="model[fields.products.name]"
            ></app-autocomplete-many-input>
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.employee.label"
          :prop="fields.employee.name"
          :required="fields.employee.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <app-autocomplete-one-input
              :fetchFn="fields.employee.fetchFn"
              v-model="model[fields.employee.name]"
            ></app-autocomplete-one-input>
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.delivered.label"
          :prop="fields.delivered.name"
          :required="fields.delivered.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-switch v-model="model[fields.delivered.name]"></el-switch>
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.attachments.label"
          :prop="fields.attachments.name"
          :required="fields.attachments.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <app-file-upload
              :max="fields.attachments.max"
              :path="fields.attachments.path"
              :schema="fields.attachments.fileSchema"
              v-model="model[fields.attachments.name]"
            ></app-file-upload>
          </el-col>
        </el-form-item>

        <el-form-item>
          <div class="form-buttons">
            <el-button
              :disabled="saveLoading"
              @click="doSubmit"
              icon="el-icon-fa-floppy-o"
              type="primary"
            >
              <app-i18n code="common.save"></app-i18n>
            </el-button>

            <el-button :disabled="saveLoading" @click="doReset" icon="el-icon-fa-undo">
              <app-i18n code="common.reset"></app-i18n>
            </el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { FormSchema } from '@/shared/form/form-schema';
import { OrderModel } from '@/modules/order/order-model';

const { fields } = OrderModel;
const formSchema = new FormSchema([
  fields.id,
  fields.customer,
  fields.products,
  fields.employee,
  fields.delivered,
  fields.attachments,
]);

export default {
  name: 'app-order-form-page',

  props: ['id'],

  data() {
    return {
      rules: formSchema.rules(),
      model: null,
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'order/form/record',
      findLoading: 'order/form/findLoading',
      saveLoading: 'order/form/saveLoading',
    }),

    isEditing() {
      return !!this.id;
    },

    fields() {
      return fields;
    },
  },

  async created() {
    if (this.isEditing) {
      await this.doFind(this.id);
    } else {
      await this.doNew();
    }

    this.model = formSchema.initialValues(this.record);
  },

  methods: {
    ...mapActions({
      doFind: 'order/form/doFind',
      doNew: 'order/form/doNew',
      doUpdate: 'order/form/doUpdate',
      doCreate: 'order/form/doCreate',
    }),

    doReset() {
      this.model = formSchema.initialValues(this.record);
    },

    async doSubmit() {
      try {
        await this.$refs.form.validate();
      } catch (error) {
        return;
      }

      const { id, ...values } = formSchema.cast(this.model);

      if (this.isEditing) {
        return this.doUpdate({
          id,
          values,
        });
      } else {
        return this.doCreate(values);
      }
    },
  },
};
</script>

<style>
</style>
